import { LinkedListEnhanced } from '@ahc-digital/component-library';
import { GetLinkedListEnhancedModel } from './C12LinkedListEnhanced.service';
import { translationClasses } from '@/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from '@/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { C12LinkedListEnhancedProps } from './C12LinkedListEnhanced.types';

const Default = (props?: C12LinkedListEnhancedProps) => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const model = GetLinkedListEnhancedModel(props);
  return (
    <LinkedListEnhanced
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};

export default checkDatasourceForRendering<C12LinkedListEnhancedProps>(Default);
